/* RS PDP — comportements des sections rs-* (clone structurel Resilia) */
(function () {
  'use strict';
  if (window.__rsPdpInit) return;
  window.__rsPdpInit = true;

  var qs = function (sel, root) { return (root || document).querySelector(sel); };
  var qsa = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ---------- Buy box : sélecteur de paliers ---------- */
  function initBuybox(box) {
    if (box.dataset.rsInit) return;
    box.dataset.rsInit = '1';
    var tiers = qsa('.rs-tier', box);
    var qtyInput = qs('input[name="quantity"]', box);
    var priceEl = qs('[data-rs="price"]', box);
    var compareEl = qs('[data-rs="compare"]', box);
    var saveEl = qs('[data-rs="save"]', box);
    var atcPrice = qs('[data-rs="atc-price"]', box);
    var atcCompare = qs('[data-rs="atc-compare"]', box);
    var container = qs('[data-ref="add-to-cart-button-container"]', box);
    var ladderItems = qsa('.rs-ladder__item', box);

    function select(tier) {
      tiers.forEach(function (t) { t.classList.toggle('is-selected', t === tier); t.setAttribute('aria-pressed', t === tier ? 'true' : 'false'); });
      var qty = parseInt(tier.dataset.qty, 10) || 1;
      box.dataset.rsQty = qty;
      qsa('input[name="quantity"]', box).forEach(function (inp) { inp.value = qty; });
      if (priceEl) priceEl.textContent = tier.dataset.price;
      if (compareEl) compareEl.textContent = tier.dataset.compare;
      if (saveEl) saveEl.textContent = tier.dataset.saveLabel;
      if (atcPrice) atcPrice.textContent = tier.dataset.price;
      if (atcCompare) atcCompare.textContent = tier.dataset.compare;
      if (container) {
        container.dataset.price = tier.dataset.priceCents;
        container.dataset.compareAtPrice = tier.dataset.compareCents;
      }
      ladderItems.forEach(function (it) {
        var min = parseInt(it.dataset.min, 10) || 1;
        it.classList.toggle('is-locked', qty < min);
      });
      box.dispatchEvent(new CustomEvent('rs:tier', { detail: { qty: qty }, bubbles: true }));
    }
    tiers.forEach(function (t) { t.addEventListener('click', function (e) { e.preventDefault(); select(t); }); });
    var def = tiers.filter(function (t) { return t.dataset.default === 'true'; })[0] || tiers[0];
    if (def) select(def);

    /* Barre de stock : pourcentage déterministe par jour, qui monte dans la fenêtre du lot */
    var fill = qs('.rs-stock__fill', box);
    var pctEl = qs('[data-rs="stock-pct"]', box);
    if (fill && pctEl) {
      var day = Math.floor(Date.now() / 86400000);
      var pct = 82 + (day % 12); // 82 → 93 %
      pctEl.textContent = pct + '%';
      requestAnimationFrame(function () { fill.style.width = pct + '%'; });
    }

    /* Date de livraison : aujourd'hui + N jours ouvrés */
    var dateEl = qs('[data-rs="delivery-date"]', box);
    if (dateEl) {
      var days = parseInt(dateEl.dataset.days, 10) || 6;
      var d = new Date();
      var added = 0;
      while (added < days) {
        d.setDate(d.getDate() + 1);
        var wd = d.getDay();
        if (wd !== 0 && wd !== 6) added++;
      }
      try {
        dateEl.textContent = d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
      } catch (err) {
        dateEl.textContent = d.toDateString();
      }
    }

    /* Ajout au panier : form-encoded (le format JSON `items` renvoie quantité 1 sur cette boutique),
       puis l'événement cart:updated du thème met à jour l'icône et ouvre le drawer. */
    var form = qs('form[data-rs="form"]', box);
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var btn = qs('[data-ref="add-to-cart-button"]', box);
        var q = parseInt(box.dataset.rsQty, 10) || 1;
        var id = form.dataset.variantId || (qs('input[name="id"]', form) || {}).value;
        if (!id || (btn && btn.classList.contains('is-loading'))) return;
        if (btn) btn.classList.add('is-loading');
        var body = new URLSearchParams();
        body.append('id', id);
        body.append('quantity', String(q));
        var sections = ['auto-gifts'];
        var drawer = document.querySelector('cart-drawer');
        if (drawer && drawer.dataset.sectionId) sections.push(drawer.dataset.sectionId);
        body.append('sections', sections.join(','));
        var addUrl = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js';
        fetch(addUrl, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' }, body: body })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res && res.status && res.status >= 400) throw new Error(res.description || res.message || 'Cart error');
            var icon = document.querySelector('cart-icon');
            var current = icon && typeof icon.getCurrentItemCount === 'function' ? icon.getCurrentItemCount() : null;
            var itemCount = (current == null || isNaN(current)) ? undefined : current + q;
            document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { resource: res, data: { itemCount: itemCount, source: 'product-form', variantId: String(id), sections: res.sections || {} } } }));
            if (!icon) {
              var d = document.querySelector('[data-ref="cart-drawer"]');
              if (d && typeof d.open === 'function') d.open();
            }
          })
          .catch(function (err) {
            console.error('RS add to cart:', err);
            document.dispatchEvent(new CustomEvent('toast:open', { detail: { type: 'error', message: String(err.message || err) } }));
          })
          .then(function () { if (btn) btn.classList.remove('is-loading'); });
      }, true);
    }
  }

  /* ---------- Galerie ---------- */
  function initGallery(g) {
    if (g.dataset.rsInit) return;
    g.dataset.rsInit = '1';
    var track = qs('.rs-gallery__track', g);
    var slides = qsa('.rs-gallery__slide', g);
    var thumbs = qsa('.rs-gallery__thumb', g);
    var dotsWrap = qs('.rs-gallery__dots', g);
    var dots = [];
    if (dotsWrap) {
      slides.forEach(function (_, i) {
        var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Image ' + (i + 1));
        b.addEventListener('click', function () { go(i); });
        dotsWrap.appendChild(b); dots.push(b);
      });
    }
    var current = 0;
    function go(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }
    function setActive(i) {
      current = i;
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      var prev = qs('.rs-gallery__arrow--prev', g), next = qs('.rs-gallery__arrow--next', g);
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
    var prevBtn = qs('.rs-gallery__arrow--prev', g), nextBtn = qs('.rs-gallery__arrow--next', g);
    if (prevBtn) prevBtn.addEventListener('click', function () { go(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { go(current + 1); });
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var w = track.clientWidth || 1;
        setActive(Math.round(track.scrollLeft / w));
      });
    });
    setActive(0);
  }

  /* ---------- Carrousels génériques ---------- */
  function initCarousel(c) {
    if (c.dataset.rsInit) return;
    c.dataset.rsInit = '1';
    var track = qs('.rs-track', c);
    if (!track) return;
    var items = Array.prototype.slice.call(track.children);
    var prev = qs('[data-rs="prev"]', c), next = qs('[data-rs="next"]', c);
    var dotsWrap = qs('.rs-dots', c);
    var dots = [];
    function perView() {
      var first = items[0]; if (!first) return 1;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0) || 0;
      return Math.max(1, Math.round((track.clientWidth + gap) / (first.getBoundingClientRect().width + gap)));
    }
    function pages() { return Math.max(1, items.length - perView() + 1); }
    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = ''; dots = [];
      for (var i = 0; i < pages(); i++) {
        var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Slide ' + (i + 1));
        (function (k) { b.addEventListener('click', function () { go(k); }); })(i);
        dotsWrap.appendChild(b); dots.push(b);
      }
    }
    function index() {
      var first = items[0]; if (!first) return 0;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0) || 0;
      var w = first.getBoundingClientRect().width + gap;
      return Math.round(track.scrollLeft / w);
    }
    function go(i) {
      i = Math.max(0, Math.min(pages() - 1, i));
      var target = items[i];
      if (target) track.scrollTo({ left: target.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }
    function update() {
      var i = index();
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= pages() - 1;
    }
    if (prev) prev.addEventListener('click', function () { go(index() - 1); });
    if (next) next.addEventListener('click', function () { go(index() + 1); });
    var raf;
    track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(update); });
    window.addEventListener('resize', function () { buildDots(); update(); });
    buildDots(); update();
  }

  /* ---------- Accordéons / dépliables ---------- */
  function initToggles(root) {
    qsa('[data-rs="toggle"]', root).forEach(function (btn) {
      if (btn.dataset.rsInit) return;
      btn.dataset.rsInit = '1';
      btn.addEventListener('click', function () {
        var item = btn.closest('[data-rs="item"]');
        if (!item) return;
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
    qsa('[data-rs="expand"]', root).forEach(function (btn) {
      if (btn.dataset.rsInit) return;
      btn.dataset.rsInit = '1';
      btn.addEventListener('click', function () {
        var target = btn.closest('[data-rs="expandable"]');
        if (target) target.classList.add('is-expanded');
      });
    });
  }

  /* ---------- Bénéfices : la carte entière bascule (le paragraphe remplace le titre) ---------- */
  function initBenefits(root) {
    qsa('.rs-benefit', root).forEach(function (card) {
      if (card.dataset.rsInit) return;
      card.dataset.rsInit = '1';
      card.addEventListener('click', function (e) {
        if (e.target.closest('a')) return;
        var open = card.classList.toggle('is-open');
        var btn = qs('.rs-benefit__btn', card);
        if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ---------- Next batch : dates et pourcentage déterministes (même calcul que la PDP actuelle) ---------- */
  function initBatch(root) {
    qsa('[data-rs="batch"]', root).forEach(function (el) {
      if (el.dataset.rsInit) return;
      el.dataset.rsInit = '1';
      var MS = 86400000;
      var n = new Date(), today = Date.UTC(n.getFullYear(), n.getMonth(), n.getDate());
      var fwd = function (ms) { var d = new Date(ms).getUTCDay(); if (d === 6) ms += 2 * MS; if (d === 0) ms += MS; return ms; };
      var back = function (ms) { var d = new Date(ms).getUTCDay(); if (d === 6) ms -= MS; if (d === 0) ms -= 2 * MS; return ms; };
      var mid = fwd(today), prev = back(mid - 2 * MS), after = fwd(mid + 12 * MS);
      var fmt = function (ms) { return new Date(ms).toLocaleDateString('en-US', { month: 'short', day: 'numeric', timeZone: 'UTC' }).toUpperCase(); };
      var hs = Math.sin(Math.floor(today / MS) * 12.9898) * 43758.5453;
      var pct = 83 + Math.floor((hs - Math.floor(hs)) * 12);
      var q = function (s) { return el.querySelector('[data-sv="' + s + '"]'); };
      if (q('d0')) q('d0').textContent = fmt(prev);
      if (q('d1')) q('d1').textContent = fmt(mid);
      if (q('d2')) q('d2').textContent = fmt(after);
      if (q('pct')) q('pct').textContent = pct + '% RESERVED';
      var fl = q('fill');
      if (fl) {
        fl.style.setProperty('--svw', pct + '%');
        if (!matchMedia('(prefers-reduced-motion:reduce)').matches) requestAnimationFrame(function () { fl.classList.add('is-anim'); });
      }
    });
  }

  /* ---------- Timeline : les étapes passent du noir au vert en avançant dans la page ---------- */
  function initTimeline(root) {
    qsa('[data-rs="timeline"]', root).forEach(function (tl) {
      if (tl.dataset.rsInit) return;
      tl.dataset.rsInit = '1';
      var weeks = qsa('.rs-week', tl);
      var fill = qs('.rs-timeline__fill', tl);
      var raf;
      function update() {
        var line = innerHeight * 0.62;
        var last = -1;
        weeks.forEach(function (w, i) {
          var active = w.getBoundingClientRect().top < line;
          w.classList.toggle('is-active', active);
          if (active) last = i;
        });
        if (fill) {
          if (last < 0) { fill.style.height = '0px'; return; }
          var tlTop = tl.getBoundingClientRect().top;
          var w = weeks[last];
          var h = w.getBoundingClientRect().top - tlTop + 15 - 12;
          fill.style.height = Math.max(0, h) + 'px';
        }
      }
      var visible = true;
      if ('IntersectionObserver' in window) {
        visible = false;
        new IntersectionObserver(function (en) { visible = en[0].isIntersecting; if (visible) update(); }, { rootMargin: '240px 0px' }).observe(tl);
      }
      window.addEventListener('scroll', function () { if (!visible) return; cancelAnimationFrame(raf); raf = requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* ---------- Vidéos : lecture avec le son au clic ---------- */
  function initVideos(root) {
    qsa('.rs-video', root).forEach(function (v) {
      if (v.classList.contains('rs-video--auto')) return;
      if (v.dataset.rsInit) return;
      v.dataset.rsInit = '1';
      if (!qs('video', v) && !qs('template', v)) return;

      /* Façade (15/09) : le <video> dort dans un <template> inerte — aucun lecteur média
         alloué, aucun octet chargé — jusqu'au premier tap. Voir snippets/rs-video-facade. */
      function media() {
        var video = qs('video', v);
        if (video) return video;
        var tpl = qs('template', v);
        if (!tpl) return null;
        v.appendChild(tpl.content.cloneNode(true));
        tpl.remove();
        video = qs('video', v);
        if (!video) return null;
        var fallback = qs('img', video);   /* <img> de repli de video_tag : jamais affiché, jamais utile */
        if (fallback) fallback.remove();
        video.addEventListener('ended', function () { v.classList.remove('is-playing'); });
        return video;
      }

      v.addEventListener('click', function () {
        var video = media();
        if (!video) return;
        if (video.paused) {
          qsa('.rs-video video').forEach(function (o) { if (o !== video) { o.pause(); o.closest('.rs-video').classList.remove('is-playing'); } });
          video.muted = false;
          video.setAttribute('playsinline', '');
          var p = video.play();
          if (p && p.catch) p.catch(function () { video.muted = true; video.play(); });
          v.classList.add('is-playing');
        } else {
          video.pause();
          v.classList.remove('is-playing');
        }
      });
    });
  }

  /* ---------- Ancres "Try risk-free" → buy box ---------- */
  function initAnchors() {
    qsa('a[href="#rs-buybox"]').forEach(function (a) {
      if (a.dataset.rsInit) return;
      a.dataset.rsInit = '1';
      a.addEventListener('click', function (e) {
        var target = document.getElementById('rs-buybox');
        if (!target) return;
        e.preventDefault();
        var top = target.getBoundingClientRect().top + window.scrollY - 90;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    });
  }

  function init(root) {
    root = root || document;
    initCounters(root);
    qsa('.rs-buybox', root).forEach(initBuybox);
    qsa('.rs-gallery', root).forEach(initGallery);
    qsa('.rs-carousel', root).forEach(initCarousel);
    initToggles(root);
    initBenefits(root);
    initBatch(root);
    initTimeline(root);
    initVideos(root);
    initAnchors();
  }

  /* ----------------------------------------------------------------------
     Compteurs de la bande de chiffres — count-up au premier passage dans le
     viewport, façon Resilia. Le suffixe (« + », « M+ », « % ») et le séparateur
     de milliers sont préservés ; les 4 chiffres démarrent en décalé.
     ---------------------------------------------------------------------- */
  function initCounters(root) {
    var els = (root || document).querySelectorAll('[data-rs-count]');
    if (!els.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function parse(raw) {
      var m = String(raw).match(/^([^0-9]*)([0-9][0-9.,]*)(.*)$/);
      if (!m) return null;
      var digits = m[2];
      var grouped = digits.indexOf(',') > -1;
      var value = parseFloat(digits.replace(/,/g, ''));
      if (isNaN(value)) return null;
      var dot = digits.indexOf('.');
      return { prefix: m[1], suffix: m[3], value: value, grouped: grouped,
               decimals: dot > -1 ? digits.length - dot - 1 : 0 };
    }
    function format(n, spec) {
      var s = spec.decimals ? n.toFixed(spec.decimals) : String(Math.round(n));
      if (spec.grouped) {
        var parts = s.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        s = parts.join('.');
      }
      return spec.prefix + s + spec.suffix;
    }
    function run(el) {
      var spec = parse(el.getAttribute('data-target') || el.textContent);
      if (!spec) return;
      if (reduce) { el.textContent = format(spec.value, spec); return; }
      var delay = parseInt(el.getAttribute('data-delay') || '0', 10);
      var dur = 1400, t0 = null;
      el.textContent = format(0, spec);
      setTimeout(function () {
        requestAnimationFrame(function step(ts) {
          if (t0 === null) t0 = ts;
          var p = Math.min((ts - t0) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);            // easeOutCubic
          el.textContent = format(spec.value * eased, spec);
          if (p < 1) requestAnimationFrame(step);
          else el.textContent = format(spec.value, spec);
        });
      }, delay);
    }
    if (!('IntersectionObserver' in window)) { [].forEach.call(els, run); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting || e.target.dataset.rsCounted) return;
        e.target.dataset.rsCounted = '1';
        run(e.target);
      });
    }, { threshold: 0.4 });
    [].forEach.call(els, function (el) {
      if (el.dataset.rsCounted || el.dataset.rsObserved) return;
      el.dataset.rsObserved = '1';
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  // Filet : les compteurs peuvent être injectés après le premier init.
  window.addEventListener('load', function () { initCounters(document); });
  [300, 1200, 3000].forEach(function (ms) { setTimeout(function () { initCounters(document); }, ms); });
})();
